import React from "react";
import styled, { css } from "styled-components";
import { SegmentedControl } from "components/bootstrap";
import { Section } from "components/common";
import IndexSetRotationRetentionLegacyConfiguration from "components/indices/IndexSetConfigurationForm/IndexSetRotationRetentionLegacyConfiguration";
import IndexSetRotationRetentionDataTieringConfiguration from "components/indices/IndexSetConfigurationForm/IndexSetRotationRetentionDataTieringConfiguration";
const ConfigSegment = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
  `
);
const IndexSetRotationRetentionConfigurationSection = ({
  values,
  indexSet,
  rotationStrategies,
  retentionStrategies,
  retentionStrategiesContext,
  hiddenFields,
  immutableFields,
  ignoreFieldRestrictions,
  isCloud,
  enableDataTieringCloud,
  selectedRetentionSegment,
  setSelectedRetentionSegment
}) => {
  const retentionConfigSegments = [
    { value: "data_tiering", label: "Data Tiering" },
    { value: "legacy", label: "Legacy (Deprecated)" }
  ];
  const legacyRenderable = () => {
    if (ignoreFieldRestrictions) return true;
    if (hiddenFields.includes("legacy") || hiddenFields.includes("legacy.rotation_strategy") && hiddenFields.includes("legacy.retention_strategy"))
      return false;
    return true;
  };
  const dataTieringFieldsRenderable = () => {
    if (isCloud && !enableDataTieringCloud) return false;
    return true;
  };
  if (!dataTieringFieldsRenderable() && !legacyRenderable()) return null;
  if (!dataTieringFieldsRenderable())
    return /* @__PURE__ */ React.createElement(Section, { title: "Rotation & Retention" }, /* @__PURE__ */ React.createElement(
      IndexSetRotationRetentionLegacyConfiguration,
      {
        indexSet,
        values,
        retentionStrategies,
        rotationStrategies,
        retentionStrategiesContext,
        hiddenFields,
        immutableFields,
        ignoreFieldRestrictions
      }
    ));
  if (!legacyRenderable())
    return /* @__PURE__ */ React.createElement(Section, { title: "Rotation & Retention" }, /* @__PURE__ */ React.createElement(
      IndexSetRotationRetentionDataTieringConfiguration,
      {
        values,
        hiddenFields,
        immutableFields,
        ignoreFieldRestrictions
      }
    ));
  return /* @__PURE__ */ React.createElement(Section, { title: "Rotation & Retention" }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    SegmentedControl,
    {
      data: retentionConfigSegments,
      value: selectedRetentionSegment,
      onChange: setSelectedRetentionSegment
    }
  ), selectedRetentionSegment === "data_tiering" ? /* @__PURE__ */ React.createElement(
    IndexSetRotationRetentionDataTieringConfiguration,
    {
      values,
      hiddenFields,
      immutableFields,
      ignoreFieldRestrictions
    }
  ) : /* @__PURE__ */ React.createElement(ConfigSegment, null, /* @__PURE__ */ React.createElement(
    IndexSetRotationRetentionLegacyConfiguration,
    {
      indexSet,
      values,
      retentionStrategies,
      rotationStrategies,
      retentionStrategiesContext,
      hiddenFields,
      immutableFields,
      ignoreFieldRestrictions
    }
  ))));
};
export default IndexSetRotationRetentionConfigurationSection;
